import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectors } from "@shared/store";

function useRoleFind(roles: string[], hospitalId: number | undefined): boolean {
  const user = useSelector(selectors.getUserDetails());

  const isRole = useMemo(() => {
    if (!user || !hospitalId) return false;

    const userRole = user?.user_roles?.find((ur) => ur.hospital_id === hospitalId);
    if (!userRole) return false;

    return !!roles.find((r) => r === userRole.role.name);
  }, [user, roles, hospitalId]);

  return isRole;
}

export default useRoleFind;
